import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  fetchEvaluationsFailure,
  fetchEvaluationsSuccess,
  fetchEvaluationFailure,
  fetchEvaluationSuccess,
  saveEvaluationFailure,
  saveEvaluationSuccess,
  updateEvaluationFailure,
  updateEvaluationSuccess,
  updatePlanEvaluationFailure,
  updatePlanEvaluationSuccess,
} from "./actions";
import {
  FETCH_EVALUATIONS,
  FETCH_EVALUATION,
  SAVE_EVALUATION,
  UPDATE_EVALUATION,
  UPDATE_PLAN_EVALUATION,
} from "./constants";

export function* fetchEvaluationsSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { id, params } = payload;
  const query = QueryString.stringify(params);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/care-plan-evaluations/${id}?${query}`,
    );
    yield put(fetchEvaluationsSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(fetchEvaluationsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching evaluations!"));
  }
}

export function* fetchEvaluationSaga({
  payload = { cancelToken: null },
  onSuccess,
}) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const id = payload;
  try {
    const { data } = yield call(
      api(token).get,
      `/api/care-plan-evaluation/${id}`,
    );
    yield put(fetchEvaluationSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(fetchEvaluationFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching evaluation!"));
  }
}

export function* saveEvaluationSaga({ payload, onSave }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/care-plan-evaluation/save`,
      payload,
    );
    if (data) {
      yield put(successAlert("Evaluation saved successfully!"));
      yield put(saveEvaluationSuccess(data));
      typeof onSave === "function" && onSave(data);
    }
  } catch (e) {
    yield put(saveEvaluationFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while saving evaluation!"));
  }
}

export function* updateEvaluationSaga({ payload, onUpdate }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { id, formData } = payload;
  try {
    const data = yield call(
      api(token).post,
      `/api/care-plan-evaluation/update/${id}`,
      formData,
    );
    if (data) {
      yield put(successAlert("Evaluation updated successfully!"));
      yield put(updateEvaluationSuccess(data));
      typeof onUpdate === "function" && onUpdate(data);
    }
  } catch (e) {
    yield put(updateEvaluationFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating evaluation!"));
  }
}

export function* updatePlanEvaluationSaga({ payload, onUpdate }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { id, formData } = payload;
  try {
    const data = yield call(
      api(token).post,
      `/api/resident-care-plan/${id}/next-evaluation-date`,
      formData,
    );
    if (data) {
      yield put(successAlert("Plan evaluation updated successfully!"));
      yield put(updatePlanEvaluationSuccess(data));
      typeof onUpdate === "function" && onUpdate(data);
    }
  } catch (e) {
    yield put(updatePlanEvaluationFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating plan evaluation!"));
  }
}

export function* fetchEvaluationsFlow() {
  yield takeEvery(FETCH_EVALUATIONS, fetchEvaluationsSaga);
}
export function* fetchEvaluationFlow() {
  yield takeEvery(FETCH_EVALUATION, fetchEvaluationSaga);
}
export function* saveEvaluationFlow() {
  yield takeEvery(SAVE_EVALUATION, saveEvaluationSaga);
}
export function* updateEvaluationFlow() {
  yield takeEvery(UPDATE_EVALUATION, updateEvaluationSaga);
}

export function* updatePlanEvaluationFlow() {
  yield takeEvery(UPDATE_PLAN_EVALUATION, updatePlanEvaluationSaga);
}
export default function* ResidentEvaluationSaga() {
  yield all([
    fetchEvaluationsFlow(),
    fetchEvaluationFlow(),
    saveEvaluationFlow(),
    updateEvaluationFlow(),
    updatePlanEvaluationFlow(),
  ]);
}
